import { get, toCurrency } from './helpers';

export default function tableSmall(data, number, variables) {
    var tbody = function (number) {
        if (number === 0) {
            return [
                [
					{alignment: "center", 	text: "Наем жилого помещения"},
					{alignment: "center", 	text: "Период"},
					{alignment: "center", 	text: "Сумма, руб."}
                ],
                [
					{text: "Начислено"},
					{alignment: "center",	text: get.point(data, number)},
					{alignment: "right",	text: toCurrency(data.bill.billPoint[number].value[0])}
                ],
                [
					{text: "Оплачено"},
                    {alignment: "center",	text: get.point(data, number)},
					{alignment: "right",	text: toCurrency(data.bill.billPoint[number].paid[0])}
                ],
            ];
        } else {
            return [
            [
                {alignment: "center", 	text: "Наем жилого помещения"},
                {alignment: "center", 	text: "Период"},
                {alignment: "center", 	text: "Сумма, руб."}
                
            ],
            [
                {text: "Начислено"},
                {alignment: "center",	text: get.point(data, number)},
                {alignment: "right",	text: toCurrency(data.bill.billPoint[number].value[0])}

            ],
            [
                {text: "Оплачено"},
                {alignment: "center",	text: get.point(data, number)},
                {alignment: "right",	text: toCurrency(data.bill.billPoint[number].paid[0])}
                
            ],
        ];
    }
};
return {
	margin: [-5,0,0,0],
    style: "underNotesSmall",
    table: {
        headerRows: 1,
        widths: [140, 90, 60],
        body: 
        tbody(number),
},
layout: {
    hLineWidth: function (i, node) {
        return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
    },
    vLineWidth: function (i, node) {
        return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
    },
    hLineColor: function (i, node) {
        return (i === 0 || i === node.table.body.length) ? "black" : "black";
    },
    vLineColor: function (i, node) {
        return (i === 0 || i === node.table.widths.length) ? "black" : "black";
    }
},

        
};
};













// WEBPACK FOOTER //
// ./src/pdf_structure_table_small_2025.js